module.exports = __webpack_public_path__ + "static/img/aiBg2.a1c8e4b1.png";